import React from 'react';
import { TileInfo } from 'app/home/index.functions';
import IconMi from 'components/common/icon/IconMi';
import { alpha, Box } from '@mui/material';

export const TileLock = function ({ style, defaultStyle, tile }: { style?: any; defaultStyle?: any; tile: TileInfo }) {
    if (tile.has_access !== 'N') return null;
    if (undefined === defaultStyle) defaultStyle = {};

    return (
        <Box
            className={'tile-element__lock'}
            style={{ ...style, ...defaultStyle }}
            sx={{ width: '16px', display: 'flex' }}
        >
            <IconMi icon={'lock'} fontSize={'15'} />
        </Box>
    );
};
